import api from '../api';
import type { User } from '../../types/user';

/**
 * Service function to get all users by a specific role.
 * @param role - The role of users to fetch (e.g., 'mentor', 'student').
 * @returns A promise that resolves to an array of User objects.
 */
export const getAllUsersByRole = async (role: string): Promise<User[]> => {
  try {
    const response = await api.get<User[]>(`/mentor/users/role/${role}`); // ✅ New backend route needed for this
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error(`Failed to fetch ${role}s.`);
  }
};

/**
 * Service function to promote a mentor to admin.
 * @param mentorId - The ID of the mentor to promote.
 * @returns A promise that resolves with a success message.
 */
export const promoteMentor = async (mentorId: string): Promise<string> => {
  try {
    const response = await api.patch<{ message: string }>(`/mentor/promote/${mentorId}`);
    return response.data.message;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to promote mentor to admin.');
  }
};

/**
 * Service function to demote an admin mentor back to a regular mentor.
 * (Needs a backend route PATCH /api/mentor/demote/:id)
 * @param mentorId - The ID of the mentor to demote.
 * @returns A promise that resolves with a success message.
 */
export const demoteMentor = async (mentorId: string): Promise<string> => {
  try {
    const response = await api.patch<{ message: string }>(`/mentor/demote/${mentorId}`); // ✅ New backend route needed
    return response.data.message;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to demote mentor from admin.');
  }
};